
import { FETCH_VEHO_ZIPCODES,USER_LOGOUT,  }  from"actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_VEHO_ZIPCODES:
           // console.log(FETCH_VEHO_ZIPCODES, action.payload);
            return {
                data: action.payload,
                fetched:true
            }
         case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
